import React, { useState, useEffect } from "react";

import {
  Container,
  Content,
  Title,
  Pagination,
  Opcoes,
  Table,
  Button,
  Label,
  Back,
} from "./styles";

import { withRouter } from "react-router-dom";
import swal from "sweetalert";

import { MdDelete, MdAdd, MdCreate, MdKeyboardBackspace } from "react-icons/md";

import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import { isAuthAdmin } from "../../../../services/auth";
import { producaov2 as api } from "../../../../services/apis";

import { Form, Input } from "semantic-ui-react";

const WebserieEpisodios = () => {
  const [colaboradores, setColaboradores] = useState(null);
  const [search, setSearch] = useState(null);
  const [reload, setReload] = useState(false);
  const [filtro, setFiltro] = useState(null);

  useEffect(() => {
    loadAuth();
  }, []);

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const deleteColaborador = async (id) => {
    api
      .delete(`/admin/webserie/colaboradores/${id}`)
      .then((res) => {
        swal(
          `Deletado com sucesso - Colaborador: ${res.data.confirmation.id} - ${res.data.confirmation.titulo} `
        );
        setReload(!reload);
      })
      .catch((err) => swal("Não foi possível deletar os dados", err.message));
  };

  useEffect(() => {
    if (
      (search === "" || search === null || isNaN(search)) &&
      filtro !== null &&
      filtro !== ""
    ) {
      api
        .get(`/webserie/colaboradores?filter=${filtro}&nome=${search}`)
        .then((res) => setColaboradores(res.data))
        .catch((err) =>
          swal("Não foi possível consultar os dados - ", err.message)
        );
    } else if (
      (search === "" || search === null) &&
      (!filtro || filtro === null)
    ) {
      api
        .get(`/webserie/colaboradores`)
        .then((res) => setColaboradores(res.data))
        .catch((err) =>
          swal("Não foi possível consultar os dados - ", err.message)
        );
    } else if (!isNaN(search)) {
      api
        .get(`/webserie/colaboradores/${search}`)
        .then((res) => {
          setColaboradores(res.data);
        })
        .catch((err) =>
          swal("Não foi possível pegar os dados - ", err.message).then(
            (window.location.href = "/admin/webserie")
          )
        );
    } else {
      api
        .get(`/webserie/colaboradores?nome=${search}`)
        .then((res) => setColaboradores(res.data))
        .catch((err) =>
          swal("Não foi possível consultar os dados - ", err.message)
        );
    }
  }, [filtro, search, reload]);

  return (
    <>
      <Container>
        <AdminMenu />
        <Content>
          <Back>
            <MdKeyboardBackspace
              onClick={() => (window.location.href = "/admin/webseries")}
            />
          </Back>
          <Title> Gerenciamento de Colaboradores </Title>

          <Form>
            <Button
              onClick={() =>
                window.open("/admin/webserie-colaborador/criar", "_self")
              }
            >
              {" "}
              Criar <MdAdd />{" "}
            </Button>
            <Form.Group widths="equal">
              <Form.Field
                control={Input}
                label="Busque pelo ID do Colaborador"
                placeholder="Busque pelo ID do Colaborador"
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
              />
            </Form.Group>
            <Form.Group widths="equal">
              <Label> Filtro por Cargo </Label>
              <select onChange={(e) => setFiltro(e.target.value)}>
                <option value={""}> Sem filtro </option>
                <option value={"convidado"}> Convidado </option>
                <option value={"host"}> Host </option>
              </select>
            </Form.Group>
          </Form>
          <Table>
            {colaboradores?.map((item) => (
              <tr>
                <td> {item.id || search} </td> <td> {item.nome} </td>{" "}
                <td onClick={() => deleteColaborador(item.id)}>
                  {" "}
                  <MdDelete />{" "}
                </td>{" "}
                <td
                  onClick={() =>
                    window.open(`/admin/webserie-colaborador/update?${item.id}`)
                  }
                >
                  <MdCreate />
                </td>
              </tr>
            ))}
          </Table>
        </Content>
      </Container>
    </>
  );
};

export default withRouter(WebserieEpisodios);
